import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { User, Lock, ArrowRight, Hammer, AlertCircle } from 'lucide-react';
import axios from 'axios';
import './AdminLogin.css';
const API_URL = 'https://api.sohanihandicrafts.com:5010';
const AdminLogin = () => {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(''); // Clear error on typing
  };

  // Handle Login Submit
// Inside handleSubmit function:

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    const response = await axios.post(`${API_URL}/api/auth/login`, formData);
    
    // Save Token to LocalStorage
    localStorage.setItem('adminToken', response.data.token);
    localStorage.setItem('adminEmail', response.data.user.email);
    
    navigate('/admin/addslider');
  } catch (err) {
    setError(err.response?.data?.msg || 'Login failed. Check server.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="lgn-wrapper">
      
      {/* Background Overlay */}
      <div className="lgn-overlay"></div>

      {/* Floating Elements (Decoration) */}
      <div className="lgn-decor-circle top-left"></div>
      <div className="lgn-decor-circle bottom-right"></div>

      <motion.div 
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="lgn-card"
      >
        {/* Logo Section */}
        <div className="lgn-header">
          <div className="lgn-logo-icon">
            <Hammer size={28} />
          </div>
          <h1>Sohani<span>Admin</span></h1>
          <p>Enter your credentials to access the artisan panel.</p>
        </div>

        {/* Error Message */}
        {error && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="lgn-error-box"
          >
            <AlertCircle size={18} />
            <span>{error}</span>
          </motion.div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="lgn-form">
          
          <div className="lgn-input-group">
            <label>Email Address</label>
            <div className="lgn-input-wrapper">
              <User size={20} className="lgn-icon" />
              <input 
                type="email" 
                name="email"
                placeholder="admin@sohani.com" 
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="lgn-input-group">
            <label>Password</label>
            <div className="lgn-input-wrapper">
              <Lock size={20} className="lgn-icon" />
              <input 
                type="password" 
                name="password"
                placeholder="••••••••" 
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="lgn-forgot">
            <a href="#">Forgot Password?</a>
          </div>

          <button type="submit" className="lgn-submit-btn" disabled={loading}>
            {loading ? (
              <span className="lgn-loader"></span>
            ) : (
              <>
                Access Dashboard <ArrowRight size={20} />
              </>
            )}
          </button>
        </form>

        <div className="lgn-footer">
          <p>Protected by Sohani Security Systems © 2026</p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;